import NewCreditCardView from "./view";
import { useNavigate } from "react-router-dom";
import useCreditCardForm from "../hooks/useCreditCardForm";

export default function NewCreditCard() {

  const navigate = useNavigate();
  
  const {
    toggleModal,
    isVisibleModal,
    isLoading,
    isDisabled,
    register,
    handleSubmit,
    errorChangeMethod,
    errors,
    success,
  } = useCreditCardForm({
    navigate,
    changeMethod: true,
  });

  const goBack = () => navigate(-1);

  return (
    <NewCreditCardView
      isLoading={isLoading}
      goBack={goBack}
      isDisabled={isDisabled}
      success={success}
      isVisibleModal={isVisibleModal}
      toggleModal={toggleModal}
      register={register}
      handleSubmit={handleSubmit}
      errorChangeMethod={errorChangeMethod}
      errors={errors}
    />
  );
}
